import { c as _c } from "react/compiler-runtime";
import type { RatingStats } from "@/entities/IProfile";
import UserPageRepsItem from "./UserPageRepsItem";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepRepsTop(t0) {
  const $ = _c(9);
  const {
    reps,
    profile,
    canEditRep
  } = t0;
  let t1;
  if ($[0] !== canEditRep || $[1] !== profile || $[2] !== reps) {
    let t2;
    if ($[4] !== canEditRep || $[5] !== profile) {
      t2 = rep => <UserPageRepsItem rep={rep} key={rep.category} profile={profile} canEditRep={canEditRep} />;
      $[4] = canEditRep;
      $[5] = profile;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = reps.map(t2);
    $[0] = canEditRep;
    $[1] = profile;
    $[2] = reps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="tw-mt-2 lg:tw-mt-4 tw-flex tw-flex-wrap tw-gap-y-4 tw-gap-x-4">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}